import { config } from "@/shared/lib/config";

/** Public URL for streaming a stored object via GET /api/files/* (requires auth cookie). */
export function getFormSubmissionFilePublicUrl(fileKey: string): string {
  const k = fileKey.replace(/^\//, "");
  return `${config.apiUrl}/files/${k}`;
}

/** Resolve storage key for a file field (column file_key and/or JSON value). */
export function resolveFormSubmissionFileFieldKey(
  fieldType: string,
  value: unknown,
  fileKey: string | null,
): string | null {
  if (fieldType !== "file") return null;
  if (fileKey && typeof fileKey === "string" && fileKey.trim()) {
    return fileKey.trim();
  }
  if (value && typeof value === "object" && !Array.isArray(value)) {
    const o = value as Record<string, unknown>;
    if (typeof o.fileKey === "string" && o.fileKey.trim())
      return o.fileKey.trim();
  }
  if (typeof value === "string" && value.trim()) return value.trim();
  return null;
}

/** Display name for downloads (metadata or last segment of key). */
export function formatFormSubmissionFileDisplayName(
  value: unknown,
  storageKey: string | null,
): string {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    const o = value as Record<string, unknown>;
    if (typeof o.fileName === "string" && o.fileName.trim()) {
      return o.fileName.trim();
    }
    if (typeof o.name === "string" && o.name.trim()) {
      return o.name.trim();
    }
  }
  if (storageKey) {
    const seg = storageKey.split("/").pop();
    if (seg) return seg;
  }
  return "ໄຟລ໌ທີ່ແນບ";
}
